import styled from 'styled-components';

export const Dot = styled.span<{ color?: string }>`
  color: ${({ theme, color }) => color || theme.palette.text.light};
`;
